import { defineStore } from "pinia"

import * as authService from "@/services/authService.js"
import * as dictionariesService from "@/services/dictionariesService.js"

export const useSessionStore = defineStore("userSession", {
  state: () => ({
    session: null,
    dictionaries: []
  }),
  actions: {
    async startLogIn(credentials) {
      const response = await authService.authenticate(credentials)
      return response.data
    },
    async verifyLogInCode(challengeId, code) {
      const response = await authService.verifyCode(challengeId, code)
      this.session = response.data
    },
    async resendLogInCode(challengeId) {
      const response = await authService.resendCode(challengeId)
      return response.data
    },
    async refreshToken() {
      if (!this.session) return
      const response = await authService.refresh(
        this.session.token,
        this.session.refreshToken
      )
      this.session = response.data
    },
    removeSession() {
      this.session = null
    },
    async fetchDictionaries() {
      try {
        this.dictionaries = await dictionariesService.getDictionaries()
      } catch {
        // ignore
      }
    }
  },
  persist: {
    pick: ["session"]
  }
})
